import React from 'react';
import { useAtmosphere } from './Atmosphere';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Vertical portrait — fixed width so it never collapses in CSS grid.
 */
export function AtmospherePortrait() {
  const { backgroundImage, brideName, groomName } = useAtmosphere();
  if (!backgroundImage) return null;

  const src = backgroundImage.startsWith('http')
    ? backgroundImage
    : `${API_URL}${backgroundImage}`;

  const couple =
    brideName && groomName ? `${brideName} & ${groomName}` : null;

  return (
    <figure
      className="relative w-[200px] sm:w-[240px] shrink-0 overflow-hidden rounded-2xl border border-border bg-card shadow-[0_12px_40px_rgba(139,30,65,0.14)]"
      data-testid="atmosphere-portrait"
    >
      <div className="relative aspect-[3/4] w-full bg-muted">
        <img
          src={src}
          alt={couple || 'Wedding atmosphere'}
          className="absolute inset-0 h-full w-full object-cover object-center"
          draggable={false}
        />
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/75 via-black/30 to-transparent p-3 pt-12">
          {couple && (
            <figcaption className="font-serif text-base sm:text-lg leading-tight text-white">
              {couple}
            </figcaption>
          )}
        </div>
      </div>
    </figure>
  );
}
